export const ORAL_STATE_KEYS = [
  "extraoral",
  "lymphNodes",
  "tonsils",
  "softPalate",
  "hardPalate",
  "buccalMucosa",
  "caudalOralMucosa",
  "tongue"
] as const;
